import gql from 'graphql-tag';
import { graphql } from '@apollo/react-hoc';
import IntlVisitReschedule from './visit-reschedule';
import { SimpleGraphQLComponent } from '../../utils/apollo';
import { withEnabledFeatures } from '../../utils/features';
import rescheduleRsvpRepVisitMutation from '../../mutations/HighSchool/rescheduleRsvpRepVisit';

const query = gql`
  query VisitReschedule($bookDayId: ID!, $cancelDayId: ID!) {
    cancelAppointmentDay:node(id: $cancelDayId) {
      id
      ... on RepVisitsDay {
        date
        appointments {
          id
          startTime
          endTime
        }
      }
    }
    bookAppointmentDay:node(id: $bookDayId) {
      id
      ... on RepVisitsDay {
        date
        timezone
        highSchool {
          id
          name
        }
        appointments {
          id
          startTime
          endTime
          userBookingStatus
          visitLocationType
        }
      }
    }
  }
`;

const graphqlData = graphql(query, {
  options: ({ bookDayId, cancelDayId }) => ({
    variables: {
      bookDayId,
      cancelDayId,
    },
  }),
});

const rescheduleRsvpRepVisit = graphql(rescheduleRsvpRepVisitMutation, {
  name: 'rescheduleRsvpRepVisit',
  options: {
    refetchQueries: ['RepVisitsOverview', 'AvailabilityCalendar', 'RepVisitsTravelPlanSearch'],
  },
});

export default withEnabledFeatures(SimpleGraphQLComponent(
  graphqlData, rescheduleRsvpRepVisit,
)(IntlVisitReschedule));
